import React from 'react';

const Footer = () => {
    return (
        <div className="bg-dark text-center text-light py-3">
            &copy; Todos los derechos reservados
        </div>
    );
};

export default Footer;